import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { dynamicTranslations } from '@shared/utils/dynamicTranslation';
import { ToastNotifications } from 'app/services/inAppToastNotifications';
import { usePut } from 'app/queryProvider';

export const useCancelTeleassistanceRequest = () => {
  const { t } = dynamicTranslations();
  const queryClient = useQueryClient();

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [requestIdToCancel, setRequestIdToCancel] = useState<string | null>(null);

  const { mutate: cancelMutate, isPending: isCancelling } = usePut<Record<string, never>, void>({
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [['appointments', 'by-month']] });
        ToastNotifications.displaySuccessNotification(t('teleassistance.card.toast.deleteSuccess'));
        setShowDeleteModal(false);
        setRequestIdToCancel(null);
      },
      onError: () => {
        ToastNotifications.displayErrorNotification(t('teleassistance.card.toast.deleteError'));
        setShowDeleteModal(false);
        setRequestIdToCancel(null);
      },
    },
  });

  const requestCancel = (requestId: string) => {
    setRequestIdToCancel(requestId);
    setShowDeleteModal(true);
  };

  const confirmCancel = () => {
    if (!requestIdToCancel) return;
    cancelMutate({
      resource: { name: 'appointments', id: requestIdToCancel },
      url: '/cancel',
      data: {},
    });
  };

  const dismissCancel = () => {
    setShowDeleteModal(false);
    setRequestIdToCancel(null);
  };

  return {
    showDeleteModal,
    isCancelling,
    requestCancel,
    confirmCancel,
    dismissCancel,
  };
};
